import { useState } from 'react'
import { Form, LinkBase, required, useNotify } from 'ra-core'
import type { SubmitHandler, FieldValues } from 'react-hook-form'
import { Button } from '@internal/ui-kit/components/ui/button'
import { TextInput } from '@internal/ui-kit/components/admin/text-input'
import { AuthPageLayout } from './AuthPageLayout'
import { requestPasswordReset } from '@/providers/authProvider'
import { extractErrorMessage } from '@internal/ui-kit/lib/httpClient'

export const RequestPasswordResetPage = () => {
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const notify = useNotify()

  const handleSubmit: SubmitHandler<FieldValues> = async (values) => {
    setLoading(true)
    try {
      await requestPasswordReset(values.email)
      setSent(true)
    } catch (error) {
      notify(extractErrorMessage(error, 'Could not request a password reset.'), { type: 'error' })
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthPageLayout
      title="Reset your password"
      description="We'll email you a link to reset your password."
      footer={
        <p className="text-sm text-muted-foreground text-center">
          <LinkBase to="/login">Back to sign in</LinkBase>
        </p>
      }
    >
      {sent ? (
        <p className="text-sm">Check your email for a link to reset your password.</p>
      ) : (
        <Form className="space-y-4" onSubmit={handleSubmit}>
          <TextInput label="Email" source="email" type="email" validate={required()} />
          <Button type="submit" className="w-full cursor-pointer" disabled={loading}>
            Send reset link
          </Button>
        </Form>
      )}
    </AuthPageLayout>
  )
}
